import type { NextPage, GetStaticProps } from 'next'
import { mediaClient } from 'src/apiMiddleware'
import { Params } from 'src/types'
import Container, { Props } from '@/containers/whitepaper/Details'
import { useRouter } from 'next/router'
import { Thanks } from '@/route'
import Head from 'next/head'
import { ArticleTag } from '@/api/types'

type StaticProps = Omit<Props, 'toThanks'> & { tags: ArticleTag[] }

export async function getStaticPaths() {
  const data = await mediaClient.whitepapers.$get({ query: { limit: 1000, offset: 0 } })

  const ids = data.contents.map((c) => c.id)

  const paths = ids.map((id) => {
    return {
      params: { id },
    }
  })

  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps<StaticProps, Params> = async ({ params }) => {
  if (params?.id === undefined) {
    return {
      props: {},
      notFound: true,
    }
  }

  try {
    const whitepaperPromise = mediaClient.whitepapers._id(params.id).$get()
    const tagPromise = mediaClient.tags.$get({ query: { limit: 1000 }})

    const [data, tags] = await Promise.all([whitepaperPromise, tagPromise])

    const breadcrumbs = [
      { title: 'Top', link: '/' },
      { title: 'お役立ち資料一覧', link: '/whitepaper/pages/1' },
      { title: data.title },
    ]

    return {
      props: {
        whitepaper: data,
        breadcrumbs,
        tags: tags.contents,
      },
    }
  } catch (e) {
    return {
      props: {},
      notFound: true,
    }
  }
}

const Pages: NextPage<Props> = (props) => {
  const router = useRouter()
  const toThanks = (title: string) => {
    router.replace({ pathname: Thanks, query: { title, type: 'whitepaper' } })
  }
  const { id, title, description, eyeCatching } = props.whitepaper
  const t = `${title}｜IoTBiz｜DXHUB株式会社`
  const metaImageUrl = eyeCatching.url + '?w=1200&h=630'
  return (
    <>
      <Head>
        <title key="title">{t}</title>
        <meta property="og:url" content={`https://iot.dxhub.co.jp/whitepapers/${id}`} key="ou" />
        <meta property="og:title" content={t} key="ot" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="od" />
        <meta property="og:image" content={metaImageUrl} key="oi" />
        <meta name="twitter:image" content={metaImageUrl} key="ti" />
      </Head>
      <Container {...props} toThanks={toThanks} />
    </>
  )
}

export default Pages
